import React from "react";
import { Link } from "react-router-dom";
import FounderVoiceAdmin from "@/components/FounderVoiceAdmin";
import FounderStoryAdmin from "@/components/FounderStoryAdmin";
import ChapterIntrosAdmin from "@/components/ChapterIntrosAdmin";
import PromptAudioAdmin from "@/components/PromptAudioAdmin";
import ReviewBadgeAdmin from "@/components/ReviewBadgeAdmin";
import TopicAdmin from "@/components/TopicAdmin";
import TrustpilotWidgetAdmin from "@/components/TrustpilotWidgetAdmin";

export default function AdminSite() {
  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 pt-16 pb-24" data-testid="admin-site-page">
      <Link to="/admin" className="font-sans text-xs uppercase tracking-[0.24em] text-bone-400 hover:text-terracotta">← Admin</Link>
      <h1 className="mt-6 font-serif text-4xl text-bone-100 mb-10">Site trust</h1>
      <FounderStoryAdmin />
      <FounderVoiceAdmin />
      <ChapterIntrosAdmin />
      <PromptAudioAdmin />
      <ReviewBadgeAdmin />
      <TrustpilotWidgetAdmin />
      <TopicAdmin />
    </div>
  );
}
